import { fetchWrapper } from 'API/authentification/fetch-wrapper';
import { getAppGatewayEndpoint } from 'core/default-endpoint-url';
import {
    CreateLocationsOrderRequest, LocationsOrderMetadata, ResolveLocationsOrderResponse,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';

const REQUEST_LOCATIONS_BASE_URL = `${getAppGatewayEndpoint()}/request-locations`;

const defaultParams = {
    basePath: '',
    endpoint: '',
};

export const requestLocationsApi = {
    createOrder(payload: Partial<CreateLocationsOrderRequest>): Promise<{order_metadata: LocationsOrderMetadata}> {
        return fetchWrapper({
            ...defaultParams,
            targetUrl: `${REQUEST_LOCATIONS_BASE_URL}/order`,
            method: 'POST',
            body: payload,
        });
    },
    resolveOrder(orderId: string): Promise<ResolveLocationsOrderResponse> {
        return fetchWrapper({
            ...defaultParams,
            targetUrl: `${REQUEST_LOCATIONS_BASE_URL}/order/${orderId}/resolve`,
            method: 'POST',
        });
    },
};
